import { FormControl, Grid, InputLabel, Select } from "@mui/material";
import { useEffect } from "react";
import { connect, useStore } from "react-redux";
import { useStyles } from "tss-react/mui";

export default connect(
  ({ subscribedSites, subscribedAreas, subscribedEquipmentpools }) => ({
    subscribedSites,
    subscribedAreas,
    subscribedEquipmentpools,
  }),
  {}
)((props) => {
  const i18n = useStore().getState().i18n;
  const { classes } = useStyles();
  const {
    subscribedSites,
    subscribedAreas,
    subscribedEquipmentpools,
    areaPoolFilterValue,
    setAreaPoolFilterValue,
    isFocused
  } = props;

  let _sites = Object.keys(subscribedSites).length > 0;

  const handleChangeFilter = (e) => {
    setAreaPoolFilterValue(e.target.value);
    window.blurAll();
  };

  useEffect(() => {
    if (Object.keys(subscribedSites).length) {
      setAreaPoolFilterValue("s==>" + Object.values(subscribedSites)[0].nodeid);
    }
  }, [subscribedSites]);

  useEffect(()=>{
    if (!_sites) {
      setAreaPoolFilterValue("p==>0");
    }
  },[])

  return (
    <Grid item className={isFocused ? "dnd_Filters_dialog" : "dnd_Filters"}>
      <FormControl variant="standard" className={classes.filterStyle}>
        <>
          <div>
            <InputLabel
              htmlFor="grouped-native-select"
              style={{
                color: "#9E9E9E",
                display: "block",
                fontSize: "12px",
                lineHeight: 1,
                marginBottom: "8px",
              }}
            >
              {i18n.machinepark}/{i18n.area}
            </InputLabel>
            <Select
              defaultValue={"Alle Bereiche"}
              native
              className="grouped-native-select"
              onChange={handleChangeFilter}
              value={areaPoolFilterValue}
              fullWidth
            >
              {subscribedSites &&
                Object.keys(subscribedSites).map((key) => {
                  return (
                    <optgroup
                      defaultValue={"Alle Bereiche"}
                      key={key}
                      label={subscribedSites[key].name}
                    >
                      <option
                        key={key}
                        value={"s==>" + subscribedSites[key].nodeid}
                      >
                        {"Alle Areas"}
                      </option>
                      {subscribedSites[key].hasarea &&
                        subscribedSites[key].hasarea.length &&
                        subscribedSites[key].hasarea.map((y, k) => {
                          return (
                            <option key={k} value={"a==>" + y.area.nodeid}>
                              {y.area.name}
                            </option>
                          );
                        })}
                    </optgroup>
                  );
                })}
              <optgroup defaultValue={"p==>0"} label={"Equipment Pools"}>
                <option value={"p==>0"}>{"Alle Equipment Pools"}</option>
                {subscribedEquipmentpools &&
                  Object.keys(subscribedEquipmentpools).map((key) => {
                    return (
                      <option
                        key={key}
                        value={"p==>" + subscribedEquipmentpools[key].nodeid}
                      >
                        {subscribedEquipmentpools[key].name}
                      </option>
                    );
                  })}
              </optgroup>
            </Select>
          </div>
        </>
      </FormControl>
    </Grid>
  );
});
